// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f6753aee","977":"048787ef"}[chunkId] + ".chunk.js";
};